import { Badge, Icon } from "@planningcenter/tapestry-react"
import { pluralize } from "utils/helpers"
import { bool, string, shape, number } from "prop-types"
import ViewOnChurchCenterButton from "./ViewOnChurchCenterButton"

const visibilityIconLookup = vis => {
  return {
    Listed: "general.showEye",
    "Not listed": "general.hideEye",
    "Link only": "general.link",
    Archived: "general.folder"
  }[vis.split("(")[0].trim()]
}

const EventCard = ({
  archived,
  churchCenterUrl,
  ccwRef,
  ccwRegistrationsPublished,
  ccwEnabled,
  logoUrl,
  name,
  open,
  timeSummary,
  visibility,
  attendeeCounts,
  noLogoUrl
}) => {
  return (
    <div className="d-f fd-c" css={{ height: "100%" }}>
      <div
        className="d-f jc-c p-r"
        css={{ backgroundColor: "var(--placeholder-image--bg-color)", width: "100%" }}
      >
        <img
          src={logoUrl ?? noLogoUrl}
          alt="Signup"
          css={{
            borderRadius: "var(--card--border-radius) var(--card--border-radius) 0 0",
            width: "100%",
            aspectRatio: "16 / 9"
          }}
        />
        <div className="p-a" css={{ top: "12px", right: "12px" }}>
          <ViewOnChurchCenterButton
            archived={archived}
            churchCenterUrl={churchCenterUrl}
            ccwRef={ccwRef}
            ccwRegistrationsPublished={ccwRegistrationsPublished}
            ccwEnabled={ccwEnabled}
            styles={{ backgroundColor: "var(--card--background-color) !important" }}
          />
        </div>
      </div>
      <div className="d-f fd-c jc-sb" css={{ padding: "12px", gap: "24px", height: "100%" }}>
        <div>
          <h3 className="d-f jc-sb ai-c fs-4 fw-600" css={{ margin: 0 }}>
            <span>{name}</span>
            <Badge
              title={open ? "Open" : "Closed"}
              size="sm"
              color={
                open
                  ? "var(--t-fill-color-status-success-ghost)"
                  : "var(--t-fill-color-status-warning-ghost)"
              }
              radius="pill"
            />
          </h3>
          <div className="fw-400 c-neutral-500">{timeSummary}</div>
        </div>
        <div className="d-f ai-c fw-400 g-1" css={{ textWrap: "nowrap", flexWrap: "wrap" }}>
          <Icon name={visibilityIconLookup(visibility)} />
          <span>{visibility}</span>
          <div
            css={{
              height: "4px",
              width: "4px",
              borderRadius: "2px",
              backgroundColor: "var(--t-fill-color-neutral-020)"
            }}
          ></div>
          <span>{pluralize("attendee", "attendees", attendeeCounts.activeCount)}</span>
        </div>
      </div>
    </div>
  )
}

EventCard.propTypes = {
  archived: bool,
  churchCenterUrl: string,
  ccwRef: string,
  ccwRegistrationsPublished: bool,
  ccwEnabled: bool,
  logoUrl: string,
  name: string,
  open: bool,
  timeSummary: string,
  visibility: string,
  attendeeCounts: shape({
    activeCount: number
  }),
  noLogoUrl: string
}

export default EventCard
